export default "__VITE_ASSET__CQJ3Cp75__"